var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Setting"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 5980",
    d: "M10.0019 18.9989C9.6132 19.0066 9.23378 18.8798 8.92796 18.6397C8.62214 18.3997 8.40872 18.0613 8.32389 17.6819C8.25997 17.4181 8.13467 17.1731 7.95818 16.9669C7.78169 16.7607 7.559 16.599 7.30824 16.4951C7.05748 16.3913 6.78573 16.348 6.51511 16.369C6.24449 16.39 5.98265 16.4746 5.75089 16.6159C5.42071 16.8166 5.03272 16.9006 4.6491 16.8544C4.26549 16.8083 3.90846 16.6347 3.63525 16.3615C3.36204 16.0883 3.18846 15.7313 3.14234 15.3477C3.09622 14.9641 3.18023 14.5761 3.38089 14.2459C3.52199 14.0142 3.60644 13.7526 3.62738 13.4821C3.64831 13.2117 3.60514 12.9401 3.50137 12.6895C3.39759 12.4389 3.23615 12.2163 3.03017 12.0398C2.82418 11.8634 2.57946 11.738 2.31589 11.6739C1.94062 11.5825 1.60693 11.3677 1.36832 11.0639C1.12971 10.7602 1 10.3851 1 9.99889C1 9.61265 1.12971 9.23759 1.36832 8.93386C1.60693 8.63013 1.94062 8.41533 2.31589 8.32389C2.57995 8.26035 2.82526 8.13532 3.03183 7.95898C3.2384 7.78265 3.40039 7.56001 3.5046 7.30919C3.6088 7.05838 3.65227 6.7865 3.63147 6.5157C3.61067 6.2449 3.52618 5.98285 3.38489 5.75089C3.18423 5.42071 3.10022 5.03272 3.14634 4.6491C3.19246 4.26549 3.36604 3.90846 3.63925 3.63525C3.91246 3.36204 4.26948 3.18846 4.6531 3.14234C5.03672 3.09622 5.42471 3.18023 5.75489 3.38089C5.9865 3.52222 6.24821 3.60685 6.51871 3.62789C6.78921 3.64894 7.06086 3.60581 7.31154 3.50201C7.56222 3.39821 7.78484 3.23668 7.96128 3.03056C8.13772 2.82445 8.26299 2.57958 8.32689 2.31589C8.41833 1.94062 8.63313 1.60693 8.93686 1.36832C9.24059 1.12971 9.61565 1 10.0019 1C10.3881 1 10.7632 1.12971 11.0669 1.36832C11.3707 1.60693 11.5855 1.94062 11.6769 2.31589C11.7408 2.57969 11.8661 2.82467 12.0426 3.03089C12.2191 3.23711 12.4418 3.39875 12.6925 3.50264C12.9433 3.60653 13.2151 3.64974 13.4857 3.62876C13.7563 3.60778 14.0181 3.5232 14.2499 3.38189C14.5801 3.18123 14.9681 3.09722 15.3517 3.14334C15.7353 3.18946 16.0923 3.36304 16.3655 3.63625C16.6387 3.90946 16.8123 4.26649 16.8584 4.6501C16.9046 5.03372 16.8206 5.42171 16.6199 5.75189C16.4788 5.98355 16.3943 6.24523 16.3734 6.51567C16.3525 6.7861 16.3956 7.05766 16.4994 7.30827C16.6032 7.55888 16.7646 7.78147 16.9706 7.95795C17.1766 8.13442 17.4213 8.2598 17.6849 8.32389C18.0669 8.40959 18.4071 8.62547 18.6474 8.93453C18.8877 9.24358 19.013 9.62658 19.0019 10.0179",
    stroke: "#0B1B4E",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5981",
    d: "M7 9.99805C7 10.5914 7.17595 11.1714 7.50559 11.6648C7.83524 12.1581 8.30377 12.5426 8.85195 12.7697C9.40013 12.9967 10.0033 13.0562 10.5853 12.9404C11.1672 12.8246 11.7018 12.5389 12.1213 12.1194C12.5409 11.6998 12.8266 11.1653 12.9424 10.5833C13.0581 10.0014 12.9987 9.39817 12.7716 8.85C12.5446 8.30182 12.1601 7.83328 11.6667 7.50364C11.1734 7.17399 10.5933 6.99805 10 6.99805C9.20435 6.99805 8.44129 7.31412 7.87868 7.87673C7.31607 8.43934 7 9.2024 7 9.99805Z",
    stroke: "#0B1B4E",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5982",
    d: "M15 16.998C15 17.3936 15.1173 17.7803 15.3371 18.1092C15.5568 18.4381 15.8692 18.6944 16.2346 18.8458C16.6001 18.9972 17.0022 19.0368 17.3902 18.9596C17.7781 18.8824 18.1345 18.692 18.4142 18.4123C18.6939 18.1326 18.8844 17.7762 18.9616 17.3882C19.0387 17.0003 18.9991 16.5981 18.8478 16.2327C18.6964 15.8672 18.44 15.5549 18.1111 15.3351C17.7822 15.1153 17.3956 14.998 17 14.998C16.4696 14.998 15.9609 15.2088 15.5858 15.5838C15.2107 15.9589 15 16.4676 15 16.998Z",
    stroke: "#0B1B4E",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5983",
    d: "M17 13.498V14.998",
    stroke: "#0B1B4E",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5984",
    d: "M17 18.998V20.498",
    stroke: "#0B1B4E",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5985",
    d: "M20.0344 15.248L18.7344 15.998",
    stroke: "#0B1B4E",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5986",
    d: "M15.2727 17.998L13.9727 18.748",
    stroke: "#0B1B4E",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5987",
    d: "M13.9727 15.248L15.2727 15.998",
    stroke: "#0B1B4E",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5988",
    d: "M18.7344 17.998L20.0344 18.748",
    stroke: "#0B1B4E",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/Setting-icon.d64fa5a6463ae6d7635485fcb4dfadde.svg";
export { ForwardRef as ReactComponent };